/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiIntRange } from '../models/ApiIntRange';
import { ApiWaveParticipationRequirement } from '../models/ApiWaveParticipationRequirement';
import { ApiWaveRequiredMetadata } from '../models/ApiWaveRequiredMetadata';
import { ApiWaveScope } from '../models/ApiWaveScope';
import { HttpFile } from '../http/http';

export class ApiWaveParticipationConfig {
    'scope': ApiWaveScope;
    /**
    * The number of applications allowed per participant. Infinite if omitted.
    */
    'no_of_applications_allowed_per_participant': number | null;
    /**
    * The metadata that must be provided by the participant.  Empty array if nothing is required. 
    */
    'required_metadata': Array<ApiWaveRequiredMetadata>;
    'required_media': Array<ApiWaveParticipationRequirement>;
    /**
    * If true then the votes must be signed by voters.
    */
    'signature_required': boolean;
    'period'?: ApiIntRange;
    'authenticated_user_eligible': boolean;
    'terms': string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "scope",
            "baseName": "scope",
            "type": "ApiWaveScope",
            "format": ""
        },
        {
            "name": "no_of_applications_allowed_per_participant",
            "baseName": "no_of_applications_allowed_per_participant",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "required_metadata",
            "baseName": "required_metadata",
            "type": "Array<ApiWaveRequiredMetadata>",
            "format": ""
        },
        {
            "name": "required_media",
            "baseName": "required_media",
            "type": "Array<ApiWaveParticipationRequirement>",
            "format": ""
        },
        {
            "name": "signature_required",
            "baseName": "signature_required",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "period",
            "baseName": "period",
            "type": "ApiIntRange",
            "format": ""
        },
        {
            "name": "authenticated_user_eligible",
            "baseName": "authenticated_user_eligible",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "terms",
            "baseName": "terms",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveParticipationConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

